<template>
    <div class="bgif">
        <iframe :src="url" id="mobsf" scrolling="no" frameborder="0" class="iframe"></iframe>
    </div>
</template> 
<script>
import { baseURL } from "@/utils/request.js";
export default {
    data() {
        return {
            url: 'http://47.104.3.68/big/#/'
        }
    },
    created(){
        let token = window.sessionStorage.getItem('Authorization');
        if(baseURL.indexOf("whwrlj")>0 || baseURL.indexOf("47.113.227.248")>0){
            this.url = 'https://whwrlj.com/big/#/?token='+token;
        }else{
            this.url = this.url + "?token="+token+"";
        }
    },
    mounted() {
        let element = document.documentElement;
        if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
    }
}
</script>
   
<style lang="scss" scoped>
.bgif {
    height: 100%;
    width: 100%;
}

.iframe {
    width: 100%;
    height: 100%;
}
</style>